import type { LineKind } from '@garage/shared'

/**
 * React Query cache keys, in one place so invalidation after a mutation is a
 * lookup rather than a guess. Every hook and every mutation uses these.
 */
export const qk = {
  dashboard: ['dashboard'] as const,
  search: (q: string) => ['search', q] as const,
  finance: (months: number) => ['finance', months] as const,
  financeAdvanced: (months: number) => ['finance-advanced', months] as const,

  clients: (params?: unknown) => ['clients', params ?? {}] as const,
  client: (id: string) => ['client', id] as const,
  clientStatement: (id: string) => ['clientStatement', id] as const,

  cars: (params?: unknown) => ['cars', params ?? {}] as const,

  jobcards: (params?: unknown) => ['jobcards', params ?? {}] as const,
  jobcard: (id: string) => ['jobcard', id] as const,
  jobcardAppointments: (params: { from: string; to: string }) => ['jobcard-appointments', params] as const,
  jobcardTimeline: (id: string) => ['jobcard', id, 'timeline'] as const,

  catalog: (params?: unknown) => ['catalog', params ?? {}] as const,
  catalogSuggest: (kind: LineKind, q: string) => ['catalog-suggest', kind, q] as const,

  settings: ['settings'] as const,

  authMe: ['auth', 'me'] as const,
  staffAccounts: ['staff-accounts'] as const,
  passkeys: ['passkeys'] as const,

  activitySummary: (entityType: string, entityId: string) => ['activity-summary', entityType, entityId] as const,
  activityFeed: (params?: unknown) => ['activity-feed', params ?? {}] as const,

  workers: (params?: unknown) => ['workers', params ?? {}] as const,
  worker: (id: string) => ['worker', id] as const,
  departments: ['departments'] as const,
  suppliers: (params?: unknown) => ['suppliers', params ?? {}] as const,
  supplier: (id: string) => ['supplier', id] as const,

  staffEvents: (params: { from: string; to: string }) => ['staff-events', params] as const,

  appointments: (params: { from: string; to: string }) => ['appointments', params] as const,

  expenses: (params?: unknown) => ['expenses', params ?? {}] as const,
  expense: (id: string) => ['expense', id] as const,
  expensesVatSummary: (params: { from: string; to: string; trn?: 'with' | 'without' | 'none' }) =>
    ['expenses-vat-summary', params] as const,

  operatingCosts: (params?: unknown) => ['operating-costs', params ?? {}] as const,
  operatingCost: (id: string) => ['operating-cost', id] as const,

  otherIncome: (params?: unknown) => ['other-income', params ?? {}] as const,
  otherIncomeItem: (id: string) => ['other-income', id] as const,

  storageTree: ['storage-tree'] as const,

  inspection: (jobcardId: string) => ['inspection', jobcardId] as const,
  inspectionTemplate: ['inspection-template'] as const,
}
